import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import { close, listupdater, loadingflas, open } from '../redux/popupSlice';


import * as APIS from "../utils/service";
import consts from '../libs/consts';

import { getMemberinfo, hpHypen, numFormat } from '../utils/utils';
import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"


export default function ProductSendPop(props) {

    const {
        setproductdetailflag=() => {},
        setproductsendflag=() => {},
        productIdx=0,
        SendDatas={},
        types=''
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);
    const mapRef = useRef(null);


    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 98){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    //console.log(category_1_setting);
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    const statusName = statusArrs;
    
    const [infoviewer, setinfoviewer] = useState(false); 
    const [nolistflag, setnolistflag] = useState(false); 
    const [detailinfos, setdetailinfos] = useState([
        {viewernames: '거래형태', values: '월세'},
        {viewernames: '매물종류', values: '상업용 > 상가'},
        {viewernames: '희망지역', values: '마포구 전체'},
        {viewernames: '희망면적', values: '23평~25평'},
        {viewernames: '보증금', values: '5,000만원'},
        {viewernames: '월세', values: '200만원'},
        {viewernames: '연식', values: '2020년 이후'},
        {viewernames: '입주시기', values: '2024년 1월 22일'},
    ]); 
    const [sendlists, setsendlists] = useState([
        {data1: true, data2: '동교동', data3: '20평', data4: '월세 3,000/200'},
        {data1: false, data2: '동교동', data3: '20평', data4: '월세 3,000/200'},
        {data1: false, data2: '동교동', data3: '20평', data4: '월세 3,000/200'},
    ]);   
    const [latlng, setlatlng] = useState({lat: 33.450701, lng: 126.570667 });   
    const [selitems, setselitems] = useState(0);   
    const [popflag, setpopflag] = useState(false); 
    const [popcomments, setpopcomments] = useState(''); 
    const [memoIdx, setmemoIdx] = useState(''); 
    const [errmsg, seterrmsg] = useState('');   

    
    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);

    useEffect(() => {
        seterrmsg('');
    }, [popcomments]);

    useEffect(() => {
        rowDataSubmit();
    }, []);
    const rowDataSubmit = () => {
        dispatch(loadingflas({ loading: true }));
        console.log(SendDatas);
        let sender = { idx: SendDatas?.idx }
        APIS.postData('/v1/customer/getItems', sender).then(({ data }) => {
            if(data){
                console.log(data, SendDatas);
                let wantAreas = SendDatas?.citys?.filter(item => item?.polygon === null)?.map(item => item.dong === '전체' ? item.sigungu+" 전체" : item.dong)?.join(", ");
                wantAreas += SendDatas?.citys?.filter(item => item?.polygon !== null)?.map((item, index) => (index === 0 && SendDatas?.citys?.filter(item => item?.polygon === null)?.length > 0) ? ", 폴리곤"+(index+1) : "폴리곤"+(index+1) )?.join(", ");

                setdetailinfos([
                    {viewernames: '거래형태', values: SendDatas?.sell_type},
                    {viewernames: '매물종류', values: category_2_setting?.find(item => item?.values*1 === SendDatas?.category_2*1)?.names},
                    {viewernames: '희망지역', values: wantAreas},
                    {viewernames: SendDatas?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(SendDatas?.price_all_min)}만원 ~ ${numFormat(SendDatas?.price_all_max)}만원`},
                    {viewernames: '월세', values: `${numFormat(SendDatas?.price_month_min)}만원 ~ ${numFormat(SendDatas?.price_month_max)}만원`},
                    {viewernames: '권리금', values: `${numFormat(SendDatas?.price_key_min)}만원 ~ ${numFormat(SendDatas?.price_key_min)}만원`},
                    {viewernames: '실투자금', values: `${numFormat(SendDatas?.price_real)}만원`},
                    {viewernames: '희망 층수', values: `${numFormat(SendDatas?.item_floor_min)}층 ~ ${numFormat(SendDatas?.item_floor_max)}층`},
                    {viewernames: '희망 면적', values: `${numFormat(SendDatas?.item_area_min)}㎡ ~ ${numFormat(SendDatas?.item_area_max)}㎡`},
                    {viewernames: '희망 연식', values: `${SendDatas?.item_year_min}년 ~ ${SendDatas?.item_year_max}년`},
                    {viewernames: '입주시기', values: `${SendDatas?.in_year} ${SendDatas?.in_year_option1 ? '협의가능' : ''}  ${SendDatas?.in_year_option2 ? '상관없음' : ''}`},
                ]);  
                setsendlists(data);
                setlatlng({lat: data[0]?.item?.lat, lng: data[0]?.item?.lng });
                setselitems(data[0]?.item?.idx);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }

    return (
        <>
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG' 
                        onClick={() => {
                            // setproductsendflag(false);
                            // if(types === ''){
                            //     setproductdetailflag(true);
                            // }
                        }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop" style={{ position: 'relative' }}> 
                        <button
                            style={{
                                position: 'absolute', right: 10, top: 10
                            }}
                            onClick={() => {
                                setproductsendflag(false);
                                if(types === ''){
                                    setproductdetailflag(true);
                                }
                            }}
                        >
                            <img src="./images/icons/close_circle_fill.svg" />        
                        </button>
                        <div className="ProductSendProfile padding32" >
                            <div
                                style={{
                                    backgroundImage: "url('"+ consts.s3url +"/"+ SendDatas?.user?.profile +"')",
                                    backgroundSize: `${SendDatas?.user?.profile ? "cover" : ""}`
                                }}                                
                            >
                                {!SendDatas?.user?.profile &&
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M26.6663 29.3334H5.33301V26.6667C5.33301 22.9848 8.31778 20 11.9997 20H19.9997C23.6815 20 26.6663 22.9848 26.6663 26.6667V29.3334ZM15.9997 17.3334C11.5814 17.3334 7.99967 13.7516 7.99967 9.33337C7.99967 4.91509 11.5814 1.33337 15.9997 1.33337C20.4179 1.33337 23.9997 4.91509 23.9997 9.33337C23.9997 13.7516 20.4179 17.3334 15.9997 17.3334Z" fill="#CCCCCC"/>
                                </svg>                        
                                }       
                            </div>
                            <div>
                                <div>{SendDatas?.compony?.title}</div>
                                <div>{SendDatas?.user?.name} {SendDatas?.user?.rank}({hpHypen(SendDatas?.user?.hp || '')})</div>
                                <div>{SendDatas?.compony?.addr}</div>
                                <div>{SendDatas?.compony?.company_phone}</div>
                            </div>
                        </div>
                        <div className="ProductSendInfos">
                            <div 
                                className='infoTxts'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    setinfoviewer(!infoviewer);
                                }}
                            >
                                <span>
                                    고객님 조건&nbsp;
                                    {SendDatas?.sell_type}, &nbsp;
                                    {SendDatas?.sell_type === '월세' ?
                                        <>
                                            보증금({numFormat(SendDatas?.price_all_min)}/{numFormat(SendDatas?.price_all_max)}),
                                            월세({numFormat(SendDatas?.price_month_min)}/{numFormat(SendDatas?.price_month_max)})
                                        </>
                                    :
                                        <>
                                            {SendDatas?.sell_type === '전세' ?
                                                <>
                                                    보증금({numFormat(SendDatas?.price_all_min)} ~ {numFormat(SendDatas?.price_all_max)})
                                                </>
                                            :
                                                <>
                                                    매매가({numFormat(SendDatas?.price_all_min)} ~ {numFormat(SendDatas?.price_all_max)})
                                                </>
                                            }
                                        </>
                                    }
                                </span>
                                <button>
                                    {infoviewer === false ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M3.57742 6.91073C3.90286 6.5853 4.4305 6.5853 4.75593 6.91073L10 12.1548L15.2441 6.91073C15.5695 6.5853 16.0972 6.5853 16.4226 6.91073C16.748 7.23617 16.748 7.76381 16.4226 8.08925L10.5893 13.9226C10.2638 14.248 9.73619 14.248 9.41075 13.9226L3.57742 8.08925C3.25198 7.76381 3.25198 7.23617 3.57742 6.91073Z" fill="#666666"/>
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.41075 6.07742C9.73619 5.75198 10.2638 5.75198 10.5893 6.07742L16.4226 11.9108C16.748 12.2362 16.748 12.7638 16.4226 13.0893C16.0972 13.4147 15.5695 13.4147 15.2441 13.0893L10 7.84519L4.75593 13.0893C4.4305 13.4147 3.90286 13.4147 3.57742 13.0893C3.25198 12.7638 3.25198 12.2362 3.57742 11.9108L9.41075 6.07742Z" fill="#666666"/>
                                    </svg>                                                            
                                    }
                                </button>                                
                            </div>
                            {infoviewer === true &&
                            <div className='infos'>
                                {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                    return (
                                        <div key={i}>
                                            <div>{x?.viewernames}</div>
                                            <div>{x?.values}</div>
                                        </div>
                                    );
                                })}
                            </div>                 
                            }           
                        </div>
                        <div>
                            <div className="productlist_th margint20" style={{ gap: 0 }}>
                                <div style={{ minWidth: '40%' }}>위치</div>
                                <div style={{ minWidth: '15%' }}>전용면적</div>
                                <div style={{ minWidth: '25%' }}>가격</div>
                                <div style={{ minWidth: '20%' }}>메모</div>
                            </div>
                            {sendlists?.length > 0 && sendlists?.filter(item => item?.delete_dt === null)?.map((x, i) => {
                                if(x?.delete_dt !== null){
                                    return;
                                }
                                return (
                                    <div 
                                        className={`productlist_td`} key={i} style={{ gap: 0, padding: '4px 0px', cursor: 'pointer' }}
                                        onClick={() => {
                                            setlatlng({lat: x?.item?.lat, lng: x?.item?.lng });
                                            setselitems(x?.item?.idx);
                                        }}
                                    >
                                        <div style={{ minWidth: '40%', minHeight: 33, justifyContent: 'flex-start', paddingLeft: 20 }}>
                                            <span style={{ 
                                                display: 'inline-block', width: 8, height: 8, backgroundColor: selitems === x?.item?.idx ? '#F00' : '',
                                                borderRadius: '50%', marginRight: 5
                                            }}></span>
                                            {x?.item?.dong}
                                        </div>                                            
                                        <div style={{ minWidth: '15%', minHeight: 33 }}>{x?.item?.area_private}㎡</div>                                            
                                        <div style={{ minWidth: '25%', minHeight: 33 }}>
                                            {x?.item?.sell_type === '월세' ?
                                                <>
                                                    {numFormat(x?.item?.price_all)}/{numFormat(x?.item?.price_month)}
                                                </>
                                            :
                                                <>
                                                    {numFormat(x?.item?.price_sell)}
                                                </>
                                            }
                                        </div>                                            
                                        <div style={{ minWidth: '20%', minHeight: 33 }} >
                                            <Button 
                                                buttonTxt={'메모'} 
                                                className={'sendmemobutton'}
                                                onPress={() => {
                                                    setpopflag(true);
                                                    setmemoIdx(x?.idx);
                                                    setpopcomments(x?.memo);
                                                }}  
                                            />                                            
                                        </div>                                           
                                    </div>
                                );
                            })}
                        </div>       
                        <div
                            style={{ 
                                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                                backgroundImage: 'url(./images/samplemap.png)', backgroundPosition: 'center', backgroundSize: 'cover',
                                height: 290
                            }}                        
                        >
                            <Map // 지도를 표시할 Container
                                id="map"
                                center={latlng}
                                style={{
                                    // 지도의 크기
                                    width: "100%",
                                    height: "100%",
                                }}
                                onCenterChanged={(map) => {
                                    const latlng = map.getCenter();
                                    setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                                }}
                                level={3} // 지도의 확대 레벨
                                ref={mapRef}
                            >  
                            </Map>
                        </div>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}
                        >
                            {types === 'customer' ? 
                            <div style={{ width: '100%'}}>
                                <Button
                                    buttonTxt={'닫기'}
                                    styles={{ 
                                        borderTopLeftRadius: 0,    
                                        borderTopRightRadius: 0,    
                                        borderBottomRightRadius: 0,    
                                    }} 
                                    onPress={() => { 
                                        setproductsendflag(false);
                                    }}
                                />                                    
                            </div>                            
                            :
                            <>
                            <div style={{ width: '70%'}}>
                                <Button
                                    buttonTxt={'매물 상세보기'}
                                    styles={{ 
                                        borderTopLeftRadius: 0,    
                                        borderTopRightRadius: 0,    
                                        borderBottomRightRadius: 0,    
                                    }} 
                                    onPress={() => { 
                                        if(types === ''){
                                            setproductdetailflag(true);
                                        }
                                        setproductsendflag(false);
                                    }}
                                />                                    
                            </div>
                            <div style={{ width: '30%'}}>
                                <Button
                                    disabled={true}
                                    buttonTxt={'제외목록'}
                                    styles={{ 
                                        borderTopLeftRadius: 0,    
                                        borderTopRightRadius: 0,    
                                        borderBottomLeftRadius: 0,    
                                    }} 
                                    onPress={() => { 
                                        if(sendlists?.length > 0){
                                            sendlists?.filter(item => item?.delete_dt !== null)?.map((x, i) => {
                                                if(i === 0){
                                                    setlatlng({lat: x?.item?.lat, lng: x?.item?.lng });
                                                    setselitems(x?.item?.idx);
                                                    setmemoIdx(x?.idx);
                                                }
                                            });
                                        }
                                        setnolistflag(true);
                                    }}
                                />                                    
                            </div>                              
                            </>
                            }
                                                      
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
            {nolistflag === true &&
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG' 
                        // onClick={() => {
                        //     setnolistflag(false);
                        // }}
                    />

                    <div></div>
                    <div className="ProductSendnolistpop"> 
                        <div className="popTitle padding20">
                            <span >제외 목록</span>
                            <button
                                onClick={() => {
                                    setnolistflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div>
                            <div className="productlist_th " style={{ gap: 0, borderTop: 0 }}>
                                <div style={{ minWidth: '40%' }}>위치</div>
                                <div style={{ minWidth: '15%' }}>전용면적</div>
                                <div style={{ minWidth: '25%' }}>가격</div>
                                <div style={{ minWidth: '20%' }}>메모</div>
                            </div>
                            {sendlists?.length > 0 && sendlists?.filter(item => item?.delete_dt !== null)?.map((x, i) => {

                                return (
                                    <div 
                                        className={`productlist_td`} key={i} style={{ gap: 0, padding: '4px 0px', cursor: 'pointer' }}
                                        onClick={() => {
                                            setlatlng({lat: x?.item?.lat, lng: x?.item?.lng });
                                            setselitems(x?.item?.idx);
                                        }}                                        
                                    >
                                        <div style={{ minWidth: '40%', minHeight: 33, justifyContent: 'flex-start', paddingLeft: 20 }}>
                                            <span style={{ 
                                                display: 'inline-block', width: 8, height: 8, backgroundColor: selitems === x?.item?.idx ? '#F00' : '',
                                                borderRadius: '50%', marginRight: 5
                                            }}></span>
                                            {x?.item?.dong}
                                        </div>                                            
                                        <div style={{ minWidth: '15%', minHeight: 33 }}>{x?.item?.area_private}㎡</div>                                            
                                        <div style={{ minWidth: '25%', minHeight: 33 }}>
                                            {x?.item?.sell_type === '월세' ?
                                                <>
                                                    {numFormat(x?.item?.price_all)}/{numFormat(x?.item?.price_month)}
                                                </>
                                            :
                                                <>
                                                    {numFormat(x?.item?.price_sell)}
                                                </>
                                            }
                                        </div>                                            
                                        <div style={{ minWidth: '20%', minHeight: 33 }} >
                                            <Button 
                                                buttonTxt={'메모'} 
                                                className={'sendmemobutton'}
                                                onPress={() => {
                                                    setpopflag(true);
                                                    setmemoIdx(x?.idx);
                                                    setpopcomments(x?.memo);
                                                }}  
                                            />                                            
                                        </div>                                             
                                    </div>
                                );
                            })}
                            {sendlists?.filter(item => item?.delete_dt !== null)?.length === 0 &&
                                <div className='nolistArea'>
                                    제외목록이 없습니다.
                                </div>                        
                            }
                        </div>       
                        {sendlists?.filter(item => item?.delete_dt !== null)?.length > 0 &&
                        <>
                        <div
                            style={{ 
                                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                                backgroundImage: 'url(./images/samplemap.png)', backgroundPosition: 'center', backgroundSize: 'cover',
                                height: 490
                            }}                        
                        >
                            <Map // 지도를 표시할 Container
                                id="map"
                                center={latlng}
                                style={{
                                    // 지도의 크기
                                    width: "100%",
                                    height: "100%",
                                }}
                                onCenterChanged={(map) => {
                                    const latlng = map.getCenter();
                                    setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                                }}
                                level={3} // 지도의 확대 레벨
                                ref={mapRef}
                            >  
                            </Map>
                        </div>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                width: '100%'
                            }}
                        >
                            <Button
                                buttonTxt={'관심매물로 이동하기'}
                                styles={{ 
                                    borderTopLeftRadius: 0,    
                                    borderTopRightRadius: 0,    
                                }} 
                                onPress={() => { 
                                    // if(types === ''){
                                    //     setproductdetailflag(true);
                                    // }
                                    // setproductsendflag(false);
                                    let sender = { idx: memoIdx }
                                    // console.log(sender);
                                    // return;
                                    dispatch(loadingflas({ loading: true }));
                                    APIS.postData('/v1/customer/customerdeleteUpdate', sender).then(({ data }) => {
                                        if(data){
                                            console.log(data, SendDatas);
                                            rowDataSubmit();
                                            setnolistflag(false);
                                        }
                                    }).catch(({ response }) => {
                                        const { data } = response;
                                        console.log(data);
                                        seterrmsg(data);
                                    }).finally(() => {
                                        dispatch(loadingflas({ loading: false }));
                                    }); 
                                }}
                            />                                    
                        </div>
                        </>
                        }
                    </div>
                    <div></div>
                </div>
            </div>       
            }     

            {popflag === true &&
            <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => { setpopflag(false); }}
                    />
                    <div className='PopupAreaContents'>
                        <div>
                            <div className="popTitle padding20">
                                <span >메모</span>
                                <button
                                    onClick={() => {
                                        setpopflag(false);
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />                                            
                                </button>
                            </div>
                            <div className="padding20">
                                <div className='popcontents'>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ width: '100%' }}>
                                            <textarea
                                                onChange={(e) => {
                                                    setpopcomments(e.target.value);
                                                }}
                                                placeholder='메모를 남겨주세요.'
                                                style={{
                                                    width: '100%', height: 200, padding: 12,
                                                    borderRadius: 4, border: '1px solid #DDD'
                                                }}
                                                value={popcomments}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                {errmsg &&
                                <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    {errmsg}
                                </div>}
                            </div>
                            {/* <div>
                                <Button
                                    buttonTxt={'확인'}
                                    onPress={() => { 
                                        if(popcomments === '' || popcomments === null){
                                            seterrmsg('메모를 입력해주세요.');
                                            return;
                                        }
                                        let sender = { idx: memoIdx, memo: popcomments }
                                        // console.log(sender);
                                        // return;
                                        dispatch(loadingflas({ loading: true }));
                                        APIS.postData('/v1/customer/customermemoUpdate', sender).then(({ data }) => {
                                            if(data){
                                                //console.log(data, SendDatas);
                                                rowDataSubmit();
                                                setpopflag(false);
                                            }
                                        }).catch(({ response }) => {
                                            const { data } = response;
                                            seterrmsg(data);
                                        }).finally(() => {
                                            dispatch(loadingflas({ loading: false }));
                                        }); 

                                    }}
                                    styles={{ height: 52, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                                />                                    
                            </div>  */}
                        </div>
                    </div>
                </div>

            </div>
            }
        </>
    )    
}